import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from 'react-router-dom';

import { Root, WithLanguage, WithoutLanguage } from '../components';
import {
    Account,
    EventDetailPage,
    EventsPage,
    NotFound,
    Preferences,
    Presales,
    Welcome,
} from '../pages';

const MAIN_ROUTES = (languageId: string) => {
    return (
        <>
            <Route
                element={<EventsPage />}
                id={`${languageId}events`}
                path=""
            />
            <Route
                element={<EventDetailPage />}
                id={`en${languageId}event-detail`}
                path="my-events/:eventId"
            />
            <Route
                element={<EventDetailPage />}
                id={`nl${languageId}event-detail`}
                path="mijn-evenementen/:eventId"
            />
            <Route
                element={<EventDetailPage />}
                id={`fr${languageId}event-detail`}
                path="mes-evenements/:eventId"
            />
            <Route
                element={<Account />}
                id={`en-${languageId}account`}
                path="account"
            />
            <Route
                element={<Account />}
                id={`nl-${languageId}account`}
                path="account"
            />
            <Route
                element={<Account />}
                id={`fr-${languageId}account`}
                path="compte"
            />
            <Route
                element={<Preferences />}
                id={`en-${languageId}preferences`}
                path="preferences"
            />
            <Route
                element={<Preferences />}
                id={`nl-${languageId}preferences`}
                path="voorkeuren"
            />
            <Route
                element={<Preferences />}
                id={`fr-${languageId}preferences`}
                path="preferences"
            />
            <Route
                element={<Welcome />}
                id={`en-${languageId}welcome`}
                path="welcome"
            />
            <Route
                element={<Welcome />}
                id={`nl-${languageId}welcome`}
                path="welkom"
            />
            <Route
                element={<Welcome />}
                id={`fr-${languageId}welcome`}
                path="bienvenue"
            />
            <Route
                element={<Presales />}
                id={`en-${languageId}presales`}
                path="presales"
            />
            <Route
                element={<Presales />}
                id={`nl-${languageId}presales`}
                path="presales"
            />
            <Route
                element={<Presales />}
                id={`fr-${languageId}presales`}
                path="preventes"
            />
        </>
    );
};

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Root />} id="main" path="">
            <Route element={<WithoutLanguage />} id="root" path="">
                {MAIN_ROUTES('')}
            </Route>
            <Route
                element={<WithLanguage />}
                id="language-root"
                path=":language"
            >
                {MAIN_ROUTES('language-')}
            </Route>
            <Route element={<NotFound />} id="not-found" path="*" />
        </Route>
    )
);

export { router };
